import store from "../store.js";

function AdminPermission(to, from, next) {
  store.dispatch("getAdminPermission");
}

export default AdminPermission;
